var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMyWrite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13.5L3.5 11L10 4.5L11.5 6L5 12.5L2.5 13.5Z",
    stroke: "#8292AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9235 3.62016C12.8729 3.49822 12.7989 3.38743 12.7055 3.29411C12.5171 3.10579 12.2615 3 11.9951 3C11.7286 3 11.473 3.10579 11.2846 3.29411L11 3.57863L12.4216 5L12.7055 4.71548C12.7989 4.62215 12.8729 4.51136 12.9235 4.38942C12.974 4.26748 13 4.13678 13 4.00479C13 3.8728 12.974 3.7421 12.9235 3.62016Z",
    stroke: "#8292AB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyWrite);
export default __webpack_public_path__ + "static/media/icon_my_write.fb4b2798320cd4c2e43c9348fd1355ab.svg";
export { ForwardRef as ReactComponent };